<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.inventory'),
                        href: meta.links.inventory_index,
                    },
                    {
                        name: $tc('messages.gamification_trades', 1),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.show'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div>
                {{ $t('messages.you_give') }}:

                <div class="bg-gray-50 rounded rounded-lg p-4 flex flex-col justify-between" style="min-height: 200px">
                    <svg
                        v-if="givenItems.length === 0"
                        class="mx-auto h-12 w-12 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            vector-effect="non-scaling-stroke"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        />
                    </svg>
                    <div v-else class="flex flex-wrap space-x-2">
                        <div
                            v-for="item in givenItems"
                            :key="`${item.id}_${item[trade.current]}`"
                            class="relative w-20 h-20"
                        >
                            <img :src="item.image_path" alt="" class="h-20 absolute" />
                            <BadgePill
                                :color="item[trade.current] ? 'indigo' : 'gray'"
                                class="absolute bottom-0 right-0"
                            >
                                &times;{{ item[trade.current] }}
                            </BadgePill>
                        </div>
                    </div>

                    <div>
                        <div class="mt-1 rounded-md shadow-sm" v-if="trade.coins[trade.current]">
                            <img class="h-6 w-6 mr-1" src="/assets/gamification/currency/coin.svg" alt="emerald" />
                            <div>
                                {{ trade.coins[trade.current] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                {{ $t('messages.you_receive') }}:

                <div class="bg-gray-50 rounded rounded-lg p-4 flex flex-col justify-between" style="min-height: 200px">
                    <svg
                        v-if="requestedItems.length === 0"
                        class="mx-auto h-12 w-12 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            vector-effect="non-scaling-stroke"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        />
                    </svg>
                    <div v-else class="flex flex-wrap space-x-2">
                        <div
                            v-for="item in requestedItems"
                            :key="`${item.id}_${item[trade.other]}`"
                            class="relative w-20 h-20"
                        >
                            <img :src="item.image_path" alt="" class="h-20 absolute" />
                            <BadgePill :color="item[trade.other] ? 'indigo' : 'gray'" class="absolute bottom-0 right-0">
                                &times;{{ item[trade.other] }}
                            </BadgePill>
                        </div>
                    </div>

                    <div>
                        <div class="mt-1 rounded-md shadow-sm" v-if="trade.coins[trade.other]">
                            <img class="h-6 w-6 mr-1" src="/assets/gamification/currency/coin.svg" alt="emerald" />
                            <div>
                                {{ trade.coins[trade.other] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3 flex space-x-2" v-if="trade.can.edit">
            <AppButton element="inertia-link" :href="meta.links.edit">
                <template v-if="trade.status === 'error'">
                    {{ $t('messages.edit') }}
                </template>
                <template v-else>
                    {{ $t('messages.counteroffer') }}
                </template>
            </AppButton>

            <InertiaLinkButton
                as="button"
                :href="meta.links.finalize"
                method="patch"
                preserve-scroll
                v-if="trade.status !== 'error'"
            >
                {{ $t('messages.confirm') }}
            </InertiaLinkButton>
        </div>
        <div v-if="trade.status === 'error'">
            <BadgePill color="yellow"> {{ $t('messages.error') }}: {{ $t('messages.quantity') }} </BadgePill>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import BadgePill from '@/components/BadgePill.vue';
import InertiaLinkButton from '@/components/InertiaLinkButton.vue';

export default {
    components: {
        PanelPage,
        AppButton,
        BadgePill,
        InertiaLinkButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'items', 'filters', 'cardCollections', 'trade'],
    data() {
        return {
            form: this.$inertia.form({
                coins: {
                    first: this.trade.coins.first,
                    second: this.trade.coins.second,
                },
            }),
        };
    },
    methods: {},
    computed: {
        givenItems: function () {
            let cards = this.cardCollections.flatMap((c) => c.cards).filter((i) => i[this.trade.current]);
            let items = this.items.filter((i) => i[this.trade.current]);
            return [...items, ...cards];
        },
        requestedItems: function () {
            let cards = this.cardCollections.flatMap((c) => c.cards).filter((i) => i[this.trade.other]);
            let items = this.items.filter((i) => i[this.trade.other]);
            return [...items, ...cards];
        },
    },
};
</script>

<style scoped>
details summary::-webkit-details-marker,
details summary::marker {
    display: none;
    content: '';
}
</style>
